import React, { useCallback, useState } from "react";
import { Animate, Fade } from "../../animation/animation";
import Button from "../button/button";
import { Lead } from "../../models/lead.model";
import { IUseWhatsappFormParams, useWhatsappForm } from "../../hooks/use-whatsapp-form.hook";
import Agreement from "../agreement/agreement";
import { phoneFormActions } from "../../reducers/phone-form/phone-form.actions";
import { useDispatch } from "react-redux";
import { setError } from "../../reducers/main/main.actions";
import { AGREEMENT_ERROR } from "../../constants";
import styles from './whatsApp-form.module.scss';

export interface IWhatsappFormProps {
  whatsappParams: IUseWhatsappFormParams;
  showAgreement?: boolean;
  showNoWhatsappButton?: boolean;
  agreementValue?: boolean;
  buttonMode?: "whatsApp" | "whatsAppInitial";
  buttonText?: string;
  onClickNoWA?: () => void;
  onSubmit: (lead: Lead) => void;
}

export function WhatsappFormDefault({ whatsappParams, onSubmit, onClickNoWA, showAgreement = false, showNoWhatsappButton = false, buttonMode = "whatsApp", buttonText, agreementValue }: IWhatsappFormProps) {
  const dispatch = useDispatch();
  const goToWhatsapp = useWhatsappForm(whatsappParams);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const onAgreementChange = useCallback((value: boolean) => {
    dispatch(phoneFormActions.update({ agreement: value }));
  }, [dispatch]);

  const validateAgreement = useCallback((value: boolean) => {
    if (!value) {
      dispatch(setError(AGREEMENT_ERROR));
      return false;
    }
    return true;
  }, []);

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);

    let validation = true;
    if (showAgreement) validation = validateAgreement(Boolean(agreementValue));

    if (onSubmit && validation) {
      const lead = await goToWhatsapp();
      onSubmit(lead);
    }

    setButtonDisabled(false);
    
  }, [goToWhatsapp, showAgreement, agreementValue, onSubmit]);

  return (<form onSubmit={handleSubmit}>
    <div className={styles.group}>
      <Fade right delay={100} duration={500} when={true}>
        <Button 
          type="submit" 
          mode={buttonMode} 
          value={buttonText || "Получить расчёт в whatsApp"}
          modifications={{ form: "squad", size: "DEFAULT", animation: "DEFAULT" }} 
          disabled={buttonDisabled}
        />
        
        {showAgreement && <Agreement 
          name='agreement' 
          onChange={(e:React.ChangeEvent<HTMLInputElement>) => onAgreementChange(e.currentTarget.checked)} 
          checked={Boolean(agreementValue)}
        />}
      </Fade>
    </div>

    <Animate name="noWA" effect={styles.noWAButtonActive} when={showNoWhatsappButton}>
      <span onClick={onClickNoWA} className={styles.noWhatsApp}>У меня нет whatsApp</span>
    </Animate>
  </form>);
}